import {Box, Typography} from '@mui/material'
import {SanitizedHtml} from '../../shared/SanitizedHtml'
import {MessageAttachment} from './MessageAttachment'

const HTML_TAG_PATTERN = /<\/?[a-z][\s\S]*>/i

export function MessageBubble({ content, date, isOurs, isRead, allowHtml, documentFileName, documentDeleted, companyIdOrderIdHash }: {
  content: string;
  date: string;
  isOurs: boolean;
  isRead?: boolean;
  allowHtml?: boolean;
  documentFileName?: string;
  documentDeleted?: boolean;
  companyIdOrderIdHash: string;
}) {
  const attachment = documentFileName ? (
    <MessageAttachment
      documentFileName={documentFileName}
      documentDeleted={documentDeleted}
      companyIdOrderIdHash={companyIdOrderIdHash}
      isOurs={isOurs}
    />
  ) : null

  if (isOurs) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
        <Box
          sx={{
            maxWidth: '85%',
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            borderRadius: '16px 4px 16px 16px',
            p: '12px 16px',
            boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
            wordBreak: 'break-word',
            ...(!allowHtml || !HTML_TAG_PATTERN.test(content) ? {whiteSpace: 'pre-wrap'} : {}),
          }}
        >
          {content && (allowHtml ? <SanitizedHtml html={content}/> : <span>{content}</span>)}
          {attachment}
        </Box>
        <Typography variant="teeny" sx={{ color: '#ABABAF', mt: 0.75, mr: 0.5, display: 'block' }}>
          You - {date} · <Box component="span" sx={{ color: isRead ? 'success.main' : 'inherit' }}>{isRead ? 'Read ✓' : 'Sent'}</Box>
        </Typography>
      </Box>
    )
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
      <Box sx={{ maxWidth: '85%' }}>
        <Box
          sx={{
            bgcolor: 'white',
            borderRadius: '4px 16px 16px 16px',
            p: '12px 16px',
            boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
            wordBreak: 'break-word',
            ...(!allowHtml || !HTML_TAG_PATTERN.test(content) ? {whiteSpace: 'pre-wrap'} : {}),
          }}
        >
          {content && (allowHtml ? <SanitizedHtml html={content}/> : <span>{content}</span>)}
          {attachment}
        </Box>
        <Typography variant="teeny" sx={{ color: '#ABABAF', mt: 0.75, ml: 0.5, display: 'block' }}>
          Title Team - {date}
        </Typography>
      </Box>
    </Box>
  )
}
